export default __webpack_public_path__ + "static/media/2.933d8b95.png";